{
  "$extensions": {
    "com.figma.modeName": "Default"
  },
  "Primary": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9725490196078431,
          0.9803921568627451,
          1
        ],
        "alpha": 1,
        "hex": "#F8FAFF"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7764705882352941,
          0.8196078431372549,
          1
        ],
        "alpha": 1,
        "hex": "#C6D1FF"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6235294117647059,
          0.6823529411764706,
          1
        ],
        "alpha": 1,
        "hex": "#9FAEFF"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4980392156862745,
          0.5490196078431373,
          1
        ],
        "alpha": 1,
        "hex": "#7F8CFF"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.4117647058823529,
          0.984313725490196
        ],
        "alpha": 1,
        "hex": "#6669FB"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3254901960784314,
          0.30196078431372547,
          0.8823529411764706
        ],
        "alpha": 1,
        "hex": "#534DE1"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2549019607843137,
          0.1803921568627451,
          0.7607843137254902
        ],
        "alpha": 1,
        "hex": "#412EC2"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.20392156862745098,
          0.07058823529411765,
          0.6470588235294118
        ],
        "alpha": 1,
        "hex": "#3412A5"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1568627450980392,
          0,
          0.5176470588235295
        ],
        "alpha": 1,
        "hex": "#280084"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.10588235294117647,
          0,
          0.37254901960784315
        ],
        "alpha": 1,
        "hex": "#1B005F"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.06274509803921569,
          0,
          0.24705882352941178
        ],
        "alpha": 1,
        "hex": "#10003F"
      }
    }
  },
  "Secondary": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.9803921568627451,
          0.9215686274509803
        ],
        "alpha": 1,
        "hex": "#FFFAEB"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9490196078431372,
          0.8196078431372549,
          0.38823529411764707
        ],
        "alpha": 1,
        "hex": "#F2D163"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8392156862745098,
          0.6941176470588235,
          0
        ],
        "alpha": 1,
        "hex": "#D6B100"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7098039215686275,
          0.592156862745098,
          0
        ],
        "alpha": 1,
        "hex": "#B59700"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5882352941176471,
          0.4980392156862745,
          0
        ],
        "alpha": 1,
        "hex": "#967F00"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.47843137254901963,
          0.40784313725490196,
          0
        ],
        "alpha": 1,
        "hex": "#7A6800"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.36470588235294116,
          0.3176470588235294,
          0
        ],
        "alpha": 1,
        "hex": "#5D5100"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2823529411764706,
          0.24313725490196078,
          0
        ],
        "alpha": 1,
        "hex": "#483E00"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.20784313725490197,
          0.1803921568627451,
          0
        ],
        "alpha": 1,
        "hex": "#352E00"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1411764705882353,
          0.12549019607843137,
          0
        ],
        "alpha": 1,
        "hex": "#242000"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.08235294117647059,
          0.07058823529411765,
          0
        ],
        "alpha": 1,
        "hex": "#151200"
      }
    }
  },
  "Tertiary": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.9764705882352941,
          1
        ],
        "alpha": 1,
        "hex": "#FBF9FF"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8666666666666667,
          0.7843137254901961,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#DDC8FD"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7647058823529411,
          0.6470588235294118,
          0.9176470588235294
        ],
        "alpha": 1,
        "hex": "#C3A5EA"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6705882352941176,
          0.5254901960784314,
          0.8313725490196079
        ],
        "alpha": 1,
        "hex": "#AB86D4"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5803921568627451,
          0.41568627450980394,
          0.7372549019607844
        ],
        "alpha": 1,
        "hex": "#946ABC"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.49019607843137253,
          0.3176470588235294,
          0.6352941176470588
        ],
        "alpha": 1,
        "hex": "#7D51A2"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.396078431372549,
          0.2196078431372549,
          0.5254901960784314
        ],
        "alpha": 1,
        "hex": "#653886"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3215686274509804,
          0.1450980392156863,
          0.43137254901960786
        ],
        "alpha": 1,
        "hex": "#52256E"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.25098039215686274,
          0.08235294117647059,
          0.3411764705882353
        ],
        "alpha": 1,
        "hex": "#401557"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1843137254901961,
          0.027450980392156862,
          0.2549019607843137
        ],
        "alpha": 1,
        "hex": "#2F0741"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.12156862745098039,
          0,
          0.17254901960784313
        ],
        "alpha": 1,
        "hex": "#1F002C"
      }
    }
  },
  "Accent": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9607843137254902,
          0.984313725490196,
          1
        ],
        "alpha": 1,
        "hex": "#F5FBFF"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6627450980392157,
          0.8549019607843137,
          1
        ],
        "alpha": 1,
        "hex": "#A9DAFF"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.47058823529411764,
          0.7411764705882353,
          0.9450980392156862
        ],
        "alpha": 1,
        "hex": "#78BDF1"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3254901960784314,
          0.6313725490196078,
          0.8666666666666667
        ],
        "alpha": 1,
        "hex": "#53A1DD"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2,
          0.5254901960784314,
          0.7803921568627451
        ],
        "alpha": 1,
        "hex": "#3386C7"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.07450980392156863,
          0.42745098039215684,
          0.6862745098039216
        ],
        "alpha": 1,
        "hex": "#136DAF"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.3254901960784314,
          0.5607843137254902
        ],
        "alpha": 1,
        "hex": "#00538F"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.24705882352941178,
          0.45098039215686275
        ],
        "alpha": 1,
        "hex": "#003F73"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.1803921568627451,
          0.34901960784313724
        ],
        "alpha": 1,
        "hex": "#002E59"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.11764705882352941,
          0.25882352941176473
        ],
        "alpha": 1,
        "hex": "#001E42"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.06666666666666667,
          0.17254901960784313
        ],
        "alpha": 1,
        "hex": "#00112C"
      }
    }
  },
  "Neutral": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.9803921568627451,
          0.9803921568627451
        ],
        "alpha": 1,
        "hex": "#FAFAFA"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8235294117647058,
          0.8274509803921568,
          0.8470588235294118
        ],
        "alpha": 1,
        "hex": "#D2D3D8"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7019607843137254,
          0.7058823529411765,
          0.7411764705882353
        ],
        "alpha": 1,
        "hex": "#B3B4BD"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.592156862745098,
          0.6,
          0.6392156862745098
        ],
        "alpha": 1,
        "hex": "#9799A3"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.49019607843137253,
          0.5019607843137255,
          0.5450980392156862
        ],
        "alpha": 1,
        "hex": "#7D808B"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.40784313725490196,
          0.4549019607843137
        ],
        "alpha": 1,
        "hex": "#666874"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3058823529411765,
          0.3137254901960784,
          0.35294117647058826
        ],
        "alpha": 1,
        "hex": "#4E505A"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.23529411764705882,
          0.24313725490196078,
          0.27450980392156865
        ],
        "alpha": 1,
        "hex": "#3C3E46"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.17254901960784313,
          0.17647058823529413,
          0.20392156862745098
        ],
        "alpha": 1,
        "hex": "#2C2D34"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.11764705882352941,
          0.12156862745098039,
          0.13725490196078433
        ],
        "alpha": 1,
        "hex": "#1E1F23"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.07058823529411765,
          0.07058823529411765,
          0.07058823529411765
        ],
        "alpha": 1,
        "hex": "#121212"
      }
    }
  },
  "Success": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9294117647058824,
          1,
          0.9725490196078431
        ],
        "alpha": 1,
        "hex": "#EDFFF8"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5215686274509804,
          0.9176470588235294,
          0.8
        ],
        "alpha": 1,
        "hex": "#85EACC"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.15294117647058825,
          0.8196078431372549,
          0.6745098039215687
        ],
        "alpha": 1,
        "hex": "#27D1AC"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.7019607843137254,
          0.5725490196078431
        ],
        "alpha": 1,
        "hex": "#00B392"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5882352941176471,
          0.4823529411764706
        ],
        "alpha": 1,
        "hex": "#00967B"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.4823529411764706,
          0.396078431372549
        ],
        "alpha": 1,
        "hex": "#007B65"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.37254901960784315,
          0.3058823529411765
        ],
        "alpha": 1,
        "hex": "#005F4E"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.2901960784313726,
          0.23529411764705882
        ],
        "alpha": 1,
        "hex": "#004A3C"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.21568627450980393,
          0.17254901960784313
        ],
        "alpha": 1,
        "hex": "#00372C"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.14901960784313725,
          0.11764705882352941
        ],
        "alpha": 1,
        "hex": "#00261E"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.08627450980392157,
          0.06666666666666667
        ],
        "alpha": 1,
        "hex": "#001611"
      }
    }
  },
  "Warning": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.9764705882352941,
          0.9647058823529412
        ],
        "alpha": 1,
        "hex": "#FFF9F6"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.7686274509803922,
          0.6588235294117647
        ],
        "alpha": 1,
        "hex": "#FFC4A8"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.596078431372549,
          0.403921568627451
        ],
        "alpha": 1,
        "hex": "#FA9867"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8941176470588236,
          0.4666666666666667,
          0.22745098039215686
        ],
        "alpha": 1,
        "hex": "#E4773A"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.796078431372549,
          0.35294117647058826,
          0
        ],
        "alpha": 1,
        "hex": "#CB5A00"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6549019607843137,
          0.28627450980392155,
          0
        ],
        "alpha": 1,
        "hex": "#A74900"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5098039215686274,
          0.2196078431372549,
          0
        ],
        "alpha": 1,
        "hex": "#823800"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.396078431372549,
          0.16470588235294117,
          0
        ],
        "alpha": 1,
        "hex": "#652A00"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2980392156862745,
          0.11764705882352941,
          0
        ],
        "alpha": 1,
        "hex": "#4C1E00"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.21176470588235294,
          0.0784313725490196,
          0
        ],
        "alpha": 1,
        "hex": "#361400"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.13333333333333333,
          0.03529411764705882,
          0
        ],
        "alpha": 1,
        "hex": "#220900"
      }
    }
  },
  "Danger": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.9725490196078431,
          0.9803921568627451
        ],
        "alpha": 1,
        "hex": "#FFF8FA"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.7450980392156863,
          0.8196078431372549
        ],
        "alpha": 1,
        "hex": "#FFBED1"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.5411764705882353,
          0.6941176470588235
        ],
        "alpha": 1,
        "hex": "#FF8AB1"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9333333333333333,
          0.3764705882352941,
          0.5803921568627451
        ],
        "alpha": 1,
        "hex": "#EE6094"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8392156862745098,
          0.23921568627450981,
          0.4745098039215686
        ],
        "alpha": 1,
        "hex": "#D63D79"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7372549019607844,
          0.08235294117647059,
          0.3803921568627451
        ],
        "alpha": 1,
        "hex": "#BC1561"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5843137254901961,
          0,
          0.2901960784313726
        ],
        "alpha": 1,
        "hex": "#95004A"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4588235294117647,
          0,
          0.2196078431372549
        ],
        "alpha": 1,
        "hex": "#750038"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.34901960784313724,
          0,
          0.1568627450980392
        ],
        "alpha": 1,
        "hex": "#590028"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.25098039215686274,
          0,
          0.10588235294117647
        ],
        "alpha": 1,
        "hex": "#40001B"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1607843137254902,
          0,
          0.054901960784313725
        ],
        "alpha": 1,
        "hex": "#29000E"
      }
    }
  },
  "Info": {
    "0": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9686274509803922,
          0.9803921568627451,
          1
        ],
        "alpha": 1,
        "hex": "#F7FAFF"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7137254901960784,
          0.8392156862745098,
          1
        ],
        "alpha": 1,
        "hex": "#B6D6FF"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5019607843137255,
          0.7215686274509804,
          1
        ],
        "alpha": 1,
        "hex": "#80B8FF"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2980392156862745,
          0.6039215686274509,
          0.984313725490196
        ],
        "alpha": 1,
        "hex": "#4C9AFB"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1607843137254902,
          0.4980392156862745,
          0.9019607843137255
        ],
        "alpha": 1,
        "hex": "#297FE6"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.396078431372549,
          0.8
        ],
        "alpha": 1,
        "hex": "#0065CC"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.30196078431372547,
          0.6313725490196078
        ],
        "alpha": 1,
        "hex": "#004DA1"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.23137254901960785,
          0.5019607843137255
        ],
        "alpha": 1,
        "hex": "#003B80"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.16862745098039217,
          0.3843137254901961
        ],
        "alpha": 1,
        "hex": "#002B62"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.10980392156862745,
          0.2784313725490196
        ],
        "alpha": 1,
        "hex": "#001C47"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.06274509803921569,
          0.1843137254901961
        ],
        "alpha": 1,
        "hex": "#00102F"
      }
    }
  }
}